module.exports = __webpack_public_path__ + "Roboto-MediumItalic.7a49ce79b6089d4d37bf.eot";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-MediumItalic.eot
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-MediumItalic.eot
// module chunks = 5